import { registerRoot } from "remotion";
import { Root } from "./root";

// Register the root component with Remotion
registerRoot(Root);
